//src/pages/HomePage.js
import React, { Suspense, lazy, useCallback, useEffect, useState } from "react";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import CategoryCards from "../components/CategoryCards";
import LazyMount from "../components/LazyMount";
import { useSeo } from "../hooks/useSeo";
import { apiRequest } from "../services/api";
import { restoreProductReturnPosition } from "../utils/navigationMemory";

const SaleBanner = lazy(() => import("../components/SaleBanner"));
const CategoryCarousel = lazy(() => import("../components/CategoryCarousel"));

const HomepageCategoryProductRows = lazy(() =>
  import("../components/HomepageCategoryProductRows")
);
const Footer = lazy(() => import("../components/Footer"));
const CartDrawer = lazy(() => import("../components/CartDrawer"));
const AddedToBagToast = lazy(() => import("../components/AddedToBagToast"));

function HomePage() {
    const [hasHomepageRows, setHasHomepageRows] = useState(true);

  const handleHomepageRowsState = useCallback((hasRows) => {
    setHasHomepageRows(hasRows);
  }, []);

  useSeo("home", null, {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${window.location.origin}/#organization`,
      name: "ETIKA",
      url: window.location.origin,
      logo: `${window.location.origin}/logo-512x512.png`,
      image: `${window.location.origin}/logo-512x512.png`,
      description:
        "ETIKA is a wholesale women’s clothing supplier in Lebanon offering stylish women’s fashion, trendy collections, and bulk clothing options for boutiques and retailers.",
      sameAs: [],
    },
    {
      "@type": "WebSite",
      "@id": `${window.location.origin}/#website`,
      url: window.location.origin,
      name: "ETIKA | Wholesale Women’s Clothing in Lebanon",
      description:
        "ETIKA is a wholesale women’s clothing supplier in Lebanon offering stylish women’s fashion, trendy collections, and bulk clothing options for boutiques and retailers.",
      publisher: {
        "@id": `${window.location.origin}/#organization`,
      },
      potentialAction: {
        "@type": "SearchAction",
        target: `${window.location.origin}/products?search={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Store",
      "@id": `${window.location.origin}/#store`,
      name: "ETIKA",
      image: `${window.location.origin}/logo-512x512.png`,
      url: window.location.origin,
      description:
        "Wholesale women’s clothing supplier in Lebanon for boutiques and retailers.",
      address: {
        "@type": "PostalAddress",
        addressCountry: "LB",
      },
      areaServed: {
        "@type": "Country",
        name: "Lebanon",
      },
      priceRange: "$$",
    },
  ],
});

 useEffect(() => {
  const trackHomeVisit = () => {
    apiRequest("/analytics/track", {
      method: "POST",
      body: JSON.stringify({
        action_type: "visit_home",
      }),
    }).catch(() => {});
  };

  if ("requestIdleCallback" in window) {
    const idleId = window.requestIdleCallback(trackHomeVisit, {
      timeout: 2500,
    });

    return () => window.cancelIdleCallback?.(idleId);
  }

  const timer = setTimeout(trackHomeVisit, 1200);
  return () => clearTimeout(timer);
}, []);

useEffect(() => {
  const timer = setTimeout(() => {
    restoreProductReturnPosition();
  }, 80);

  return () => clearTimeout(timer);
}, []);


  return (
    <div
      className="
  w-full min-h-screen flex flex-col overflow-x-hidden
  bg-white
"
    >
      {/* FIXED TOP LAYER */}
      <TopBanner />
      <MainHeader
        onMenuOpen={() => console.log("Menu drawer opens")}
        onSearchOpen={() => console.log("Search opens")}
        onBagOpen={() => console.log("Bag page")}
      />

{/* GLOBAL UI LAYERS */}
<Suspense fallback={null}>
  <CartDrawer />
  <AddedToBagToast />
</Suspense>

      {/* PAGE FLOW */}
      <div className="w-full bg-white">
        {/* TOP DISCOVERY */}
        <div className="w-full bg-white">
  <CategoryCards />

<LazyMount
  rootMargin="900px"
  placeholderClassName="min-h-[120px]"
>
  <Suspense fallback={null}>
    <div className="mt-2">
      <SaleBanner />
    </div>
  </Suspense>
</LazyMount>

<LazyMount
  rootMargin="900px"
  placeholderClassName="min-h-[170px] md:min-h-[240px]"
>
  <Suspense fallback={null}>
    <div className="mt-1">
      <CategoryCarousel />
    </div>
  </Suspense>
</LazyMount>



        </div>

        {/* FOOTER */}
        <LazyMount
  rootMargin="1200px"
  placeholderClassName="min-h-[420px]"
>
  <Suspense fallback={null}>
    <Footer className="mt-auto" />
  </Suspense>
</LazyMount>
      </div>
      
    </div>
  );
}

export default HomePage;
